// extracted by mini-css-extract-plugin
export default {"socialLink":"SocialLink--socialLink--rTG0p"};